import { clearPendingAction } from '@/lib/auth/pending-action';

const APP_STATE_KEYS = [
  'ertzyx_import_preferences_v1',
  'ertzyx_user_preferences_v1',
  'ertzyx_offline_queue',
  'ertzyx_saved_ledger_items_v1',
  'ertzyx-dashboard-theme',
  'ertzyx.dashboardSidebarCollapsed',
  'ertzyx_presentation_demo',
  'ertzyx.profileEnsureWarning',
] as const;

const APP_STATE_PREFIXES = ['ertzyx_', 'ertzyx.', 'ertzyx:'] as const;

/** Clear app caches that can leak role/plan/dashboard context across account switches. */
export function clearSessionAppState(): void {
  clearPendingAction();
  if (typeof window === 'undefined') return;
  try {
    for (const key of APP_STATE_KEYS) {
      localStorage.removeItem(key);
      sessionStorage.removeItem(key);
    }
    Object.keys(localStorage).forEach((key) => {
      if (APP_STATE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        localStorage.removeItem(key);
      }
    });
    Object.keys(sessionStorage).forEach((key) => {
      if (APP_STATE_PREFIXES.some((prefix) => key.startsWith(prefix))) {
        sessionStorage.removeItem(key);
      }
    });
  } catch {
    // ignore quota / private mode
  }
}
